export enum WhatsappFollowupSendTime {
  HalfHour = 1,
  OneHour = 2 ,
  TwoHours = 3,
}